import { recoilPersist } from "recoil-persist";

import { atom } from "recoil";
import { encryptString } from "util/encryptUtil";

export type UserInfo = {
  account: string;
  local: string;
  role: string;
  name: string;
  latestDt: string;
  isAuthenticated: boolean;
  factoryId: string;
  deptId: string;
  acceptUserId: string,
  acceptUserRole: string
  useAcceptRole: boolean;
}

export const userInfoPersist = recoilPersist({
  key: 'userInfo',
  storage: sessionStorage,
  converter: JSON
})

export const userInfoState = atom<UserInfo>({
  key: 'userInfoState',
  default: {
    account: '',
    local: '',
    role: encryptString('1'),
    name: '',
    latestDt: '',
    isAuthenticated: false,
    factoryId: '',
    deptId: '',
    acceptUserId: '',
    acceptUserRole: '',
    useAcceptRole: false
  },
  effects_UNSTABLE: [userInfoPersist.persistAtom]
})
